module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bulb2-6340eed315330dde6bb3504f611089f3.svg";